'use client';

import dynamic from 'next/dynamic';
import { useState } from 'react';
import { label, type Labels } from './labels';

// The viewer and pdf.js behind it load on the first press — hover or focus starts the viewer's
// own (small) chunk a moment early; pdf.js itself is only fetched once the dialog is open.
const PdfPreview = dynamic(() => import('./PdfPreview'), { ssr: false });
const preload = () => {
  void import('./PdfPreview');
};

/** The one interactive part of a document row: "Preview", opening the PDF viewer. */
export function PdfPreviewButton({
  url,
  downloadUrl,
  title,
  labels,
  className,
}: {
  url: string;
  downloadUrl: string;
  title: string;
  labels: Labels;
  className: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        data-document-preview
        aria-label={label(labels, 'media.document.previewLabel', { title })}
        onClick={() => setOpen(true)}
        onPointerEnter={preload}
        onFocus={preload}
        className={className}
      >
        {label(labels, 'media.document.preview')}
      </button>
      {open ? (
        <PdfPreview
          url={url}
          downloadUrl={downloadUrl}
          title={title}
          labels={labels}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
